// Copyright (c) 2022 Siemens
import AwIcon from 'viewmodel/AwIconViewModel';
import wcagSvc from 'js/wcagService';
import { getCompClass } from 'js/componentUtils';
import sanitizer from 'js/sanitizer';
import _ from 'lodash';

export function createKeyDownHandlerFun(allOtherProps) {
    return (event) => {
        if (allOtherProps.changeAction) {
            if (event.key !== 'Enter') {
                _.defer(function () {
                    allOtherProps.changeAction();
                }
                );
            } else {
                event.preventDefault();
            }
        } else if (allOtherProps.action && event.key === 'Enter') {
            event.preventDefault();
            allOtherProps.action();
        }
    };
}

export function createDoSearchFun(allOtherProps, closeAction) {
    return (event) => {
        event.preventDefault();
        if (allOtherProps.changeAction) {
            _.defer(function () {
                allOtherProps.changeAction();
            }
            );
        } else if (allOtherProps.action) {
            allOtherProps.action();
        }
        if (closeAction) {
            closeAction();
        }
    };
}

export function createResetFun(prop, props, resetAction) {
    return (event) => {
        const inputProp = prop ? prop : props;
        if (inputProp) {
            inputProp.value = '';
            event.preventDefault();
            const evt = {
                target: {
                    value: inputProp.value
                }
            };
            inputProp.onChange(evt);
            if (resetAction) {
                resetAction();
            }
        }
    };
}

export function createClickHandlerFun(clickAction) {
    return (event) => {
        if (clickAction) {
            clickAction();
        }
        setTimeout(() => {
            event.target.focus();
        }, 2000);
    };
}

export const onFocusHandler = (searchInput) => {

    if (!searchInput) {
        document.getElementsByClassName("aw-uiwidgets-searchBox").searchBox.click();
    }
}

export const accSearchBoxServiceRenderFunction = (props) => {
    const { prop, onKeyDown, closeAction, resetAction, i18n, clickAction, ...allOtherProps } = props;
    const propValue = _.get(prop, 'value', _.get(props, 'value', ''));
    const hasInput = propValue.length > 0;

    let keyDownHandler = onKeyDown;

    if (!keyDownHandler) {
        keyDownHandler = createKeyDownHandlerFun(allOtherProps);
    }

    const doSearch = createDoSearchFun(allOtherProps, closeAction);

    const doSearchKeyPress = (event) => {
        if (wcagSvc.isValidKeyPress(event)) {
            doSearch(event);
        }
    };

    const reset = createResetFun(prop, props, resetAction);

    const clearContentKeyPress = (event) => {
        if (wcagSvc.isValidKeyPress(event)) {
            reset(event);
        }
    };

    const onClickHandler = createClickHandlerFun(clickAction);

    const inputProps = { ...prop, ...allOtherProps };
    const sanitizedProps = sanitizer.sanitizeHTMLTagProps(inputProps, 'input');
    if (sanitizedProps && sanitizedProps.value === null) {
        delete sanitizedProps.value;
    }

    if (props['ixEnabled'] !== "true") {
        return (
            <div className='aw-in-content-search-box'>
                <div className={getCompClass('aw-uiwidgets-searchBoxContainer', props)}>
                    <input autoComplete='off'
                        className='aw-uiwidgets-searchBox'
                        type='text'
                        {...sanitizedProps}
                        onKeyDown={keyDownHandler}
                        onClick={onClickHandler}
                    >
                    </input>
                    {hasInput &&
                        <span role='button' tabIndex='0' onClick={(event) => reset(event)} onKeyDown={(event) => clearContentKeyPress(event)} className='aw-uiwidgets-searchResetIcon'>
                            <AwIcon iconId='cmdClearText'></AwIcon>
                        </span>
                    }
                    <span role='button' tabIndex='0' aria-label={i18n.SEARCH_LABEL} onClick={(event) => doSearch(event)}
                        onKeyDown={(event) => doSearchKeyPress(event)} className='aw-uiwidgets-searchBoxIcon'>
                        <AwIcon iconId='cmdSearch'></AwIcon>
                    </span>
                </div>
            </div>
        );
    } else {
        const divStyle = {
            'border': 'none',
            'box-shadow': 'none'
        };
        return (
            <div className='aw-in-content-search-box'>
                <div style={divStyle} className={getCompClass('aw-uiwidgets-searchBoxContainer', props)}>
                    <input autoComplete='off'
                        id='ix-input'
                        className='search-box-acc-ix-brand-input'
                        type='text'
                        {...sanitizedProps}
                        onKeyDown={keyDownHandler}
                        onClick={onClickHandler}
                    >
                    </input>
                    {hasInput &&
                        <span
                            role='button'
                            tabIndex='0'
                            onClick={(event) => reset(event)}
                            onKeyDown={(event) => clearContentKeyPress(event)}
                            className="search-box-acc-ix-brand-clear-icon-span"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="search-box-acc-ix-brand-clear-icon"
                            >
                                <line x1="18" y1="6" x2="6" y2="18"></line>
                                <line x1="6" y1="6" x2="18" y2="18"></line>
                            </svg>
                        </span>
                    }
                    <span
                        role='button'
                        tabIndex='0'
                        aria-label={i18n.SEARCH_LABEL}
                        onClick={(event) => doSearch(event)}
                        onKeyDown={(event) => doSearchKeyPress(event)}
                        className="search-box-acc-ix-brand-search-icon-span"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="search-box-acc-ix-brand-search-icon"
                        >
                            <circle cx="11" cy="11" r="8"></circle>
                            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                        </svg>
                    </span>
                </div>
            </div>
        );
    }

};
